export default __webpack_public_path__ + "static/milkcake-544812e68b4b4990a00c08b4ead7656e.png";